<template>
  <div class="flex h-full flex-col items-center justify-center gap-4">
    <p>{{ t('extracting') }}</p>
    <div class="h-1 w-48 animate-pulse rounded-md bg-hazel-300" />
    <img :src="loadingGif" class="h-48 w-full object-contain" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const loadingGifs = [
  'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExb28xNnkwdmRvZjB4ZjQwbDN5c3MyNXlveTB5eTB3a2Ryd3Boa3FjaCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/VISOlbIUr7CQvRg8P8/200.webp',
  'https://media0.giphy.com/media/7u2C8KfT7XoiLJhrWH/200.webp?cid=ecf05e47mgfiavw1l816kf7ifa934hoal6d6gk7d8ev5st6f&ep=v1_gifs_search&rid=200.webp&ct=g',
  'https://media2.giphy.com/media/cMbZ3YwBMneMH4Ui9O/giphy.webp?cid=ecf05e47ztrgffdxqlguof1pyevsbt1wlfg70g1j0wgzd5uy&ep=v1_gifs_search&rid=giphy.webp&ct=g',
  'https://media4.giphy.com/media/1Wa1nYNk0GXDBk1PZJ/giphy.webp?cid=ecf05e47c9fco5yuhs7e7r7geghzk3zcwjxqrka9kmqis1qc&ep=v1_gifs_search&rid=giphy.webp&ct=g',
  'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExbXlyYm9mdHVqOG82c2VhbTdibnhwNmJtb3c0M3o3bmF4NDNmdXZqeSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/sFTWiBKYYWKVa/giphy.webp',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDhuc25yYWQ1MjN6N24yODEzNjg3NzJ4Y3lmOXFoNnU2YjhndTYwZSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/WoWm8YzFQJg5i/200.webp',
  'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDhuc25yYWQ1MjN6N24yODEzNjg3NzJ4Y3lmOXFoNnU2YjhndTYwZSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/NFA61GS9qKZ68/200.webp',
  'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDhuc25yYWQ1MjN6N24yODEzNjg3NzJ4Y3lmOXFoNnU2YjhndTYwZSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/1iu8uG2cjYFZS6wTxv/giphy.webp',
  'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDhuc25yYWQ1MjN6N24yODEzNjg3NzJ4Y3lmOXFoNnU2YjhndTYwZSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/8dYmJ6Buo3lYY/200.webp',
  'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExaHBxcm5jNmpiMGExMzJic29vazI4cTV3ZWhheWoyZ2xpdmZmNm1sbCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/WRQBXSCnEFJIuxktnw/200.webp',
  'https://media2.giphy.com/media/w0vFxYaCcvvJm/200.webp?cid=ecf05e472broxpnccyucox4lu129pa5a17yvxhj9ndzxu2sj&ep=v1_gifs_related&rid=200.webp&ct=g',
];

const loadingGif = computed(() => {
  return loadingGifs[Math.floor(Math.random() * loadingGifs.length)];
});
</script>

<i18n lang="json">
{
  "en": {
    "extracting": "Extracting data..."
  },
  "de": {
    "extracting": "Daten werden extrahiert..."
  },
  "es": {
    "extracting": "Extrayendo datos…"
  }
}
</i18n>
